export interface IVideoDto {
    title: string;
    thumbnail: string;
    youtube_published_at: string;
    view_count: number;
    slug: string;
    youtube_video_id: string;
    highlighted: boolean;
    youtube_url: string;
    description: string | null;
}

export interface IVideoListDto {
    count: number;
    results: IVideoDto[];
}

export type IVideoCard = IVideoDto;

export enum TabValues {
    LATEST = 'latest',
    MOST_VIEWED = 'most-viewed',
}
